export enum LinkTypeDto {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  TWITTER = 'TWITTER',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  SERVICE_TERMS = 'SERVICE_TERMS',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
}

export interface SocialMediaLinksDto {
  facebookLink: string;
  twitterLink: string;
  youtubeLink: string;
  instagramLink: string;
}

export interface LegalLinksDto {
  privacyLink: string;
  serviceTermsLink: string;
  termsAndConditionsLink: string;
}

export interface linkDataDto {
  businessRegion: string;
  geoRegion: string;
  linkType: LinkTypeDto;
  url: string;
  countryCode: string;
}

export interface RegionDataDto {
  businessRegion: string;
  links: linkDataDto[];
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/region-data-dto.ts